import { render } from "./SuperAdminListCompany.vue?vue&type=template&id=13fb9cad"
import script from "./SuperAdminListCompany.vue?vue&type=script&lang=js"
export * from "./SuperAdminListCompany.vue?vue&type=script&lang=js"

import "./SuperAdminListCompany.vue?vue&type=style&index=0&id=13fb9cad&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__